function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, "\n      .crapomaticTitle1 {\n        fill: #c60e2d;\n      }\n\n      .crapomaticTitle2 {\n        fill: #329cfc;\n      }\n\n      .crapomaticTitle3 {\n        fill: #fff;\n      }\n\n      .crapomaticTitleDash2 {\n        fill: #fff;\n      }\n      .crapomaticTitleDash1 {\n        fill: #fff;\n        stroke: #cbcdcf;\n        stroke-miterlimit: 10;\n        stroke-width: 0.82px;\n      }\n    "));

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  id: "matic-C",
  className: "crapomaticTitle1",
  d: "M349.51,5.43c-6.92,0-10.37,4.94-10.37,13.23,0,8.62,2.85,13.94,10.48,13.78a14,14,0,0,0,4-.5c1-.33,1.15-.76,1.15-1.81V25.74l5.6.39v9.49a25.11,25.11,0,0,1-10.87,2.25c-11.14,0-17.23-6.26-17.23-18.77,0-14.32,8.78-19.1,17.23-19.1a25.15,25.15,0,0,1,10.32,2.25v9.33l-5.6.39V7.68c0-1-.16-1.48-1.15-1.81A13,13,0,0,0,349.51,5.43Z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  id: "matic-I",
  className: "crapomaticTitle2",
  d: "M322.23,5.49l-3.13-.17V.66h13.29V5.1l-1.82.17A1.52,1.52,0,0,0,329,7v25.3l3.13.16v4.67H318.83V32.71l1.81-.16c1-.11,1.59-.44,1.59-1.81Z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  id: "matic-T",
  className: "crapomaticTitle3",
  d: "M299.23,6.09H295c-1.15,0-1.26.77-1.26,1.7v2.58l-5.6-.38V.66H316.8V10l-5.6.38V7.79c0-1-.11-1.7-1.59-1.7h-3.73V32.33l4.33.16v4.67H294.73V32.71l2.91-.16c1.05-.11,1.59-.44,1.59-1.54Z"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  id: "matic-A",
  className: "crapomaticTitle2",
  d: "M267.35,5.43l-3.46-.33V.66h12.57l11.2,31.67h0l3.13.16v4.67H276.68V32.71l2.08-.16c1.16-.11,1.7-.44,1.32-1.65l-1.15-3.4H266.08l-1.64,4.83,3.29.16v4.67H255.05V32.71l1.81-.16c.94-.11,1.27-.5,1.65-1.54Zm0,17h10.21L272.67,6.81h-.16Z"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  id: "matic-M",
  className: "crapomaticTitle1",
  d: "M230.3,25.47h.11L239.79.66h10.87V5.1l-1.81.17c-1,.11-1.65.44-1.59,1.92l1.37,25.14,3.4.16v4.67H238.81V32.71l2-.16c.88-.06,1.48-.39,1.43-1.43l-1-19.37h-.11l-8.46,21.9h-5.21L219.05,12h-.11l-1.1,20.36,3.57.16v4.67h-13V32.71l2-.16a1.46,1.46,0,0,0,1.37-1.48l1.48-25.53-3.34-.22V.66h11Z"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  id: "dash-2",
  className: "crapomaticTitleDash2",
  d: "M191.88,18.83h14.38v5.05H191.88Z"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  id: "o-O",
  className: "crapomaticTitle2",
  d: "M172.45,37.87c-9.77,0-15.92-6.37-15.92-18.88,0-14,8.84-19,16.52-19,8.18,0,15.54,5.05,15.54,19C188.59,31.56,182.06,37.87,172.45,37.87Zm.38-5.54c7,0,8.95-6.59,8.95-13.17,0-5.6-1.48-13.51-9.06-13.51-7,0-9.33,6.54-9.33,13.07C163.39,25,164.93,32.33,172.83,32.33Z"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  id: "dash-1",
  className: "crapomaticTitleDash1",
  d: "M138.86,18.83h14.38v5.05H138.86Z"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  id: "crap-P",
  className: "crapomaticTitle1",
  d: "M107.14,32.71l1.81-.16c.93-.11,1.59-.44,1.59-1.54V5.49l-3.13-.17V.66h15.7c8.07,0,13,3.84,13,11.2,0,8.34-5.93,12.51-14.22,12.51h-4.66v8l5.26.16v4.67H107.14Zm14-13.66c4.77,0,8-1.65,8-6.54C129.2,6.86,126,6,120.58,6h-3.34V19.05Z"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  id: "crap-A",
  className: "crapomaticTitle3",
  d: "M81.07,5.43,77.61,5.1V.66H90.18l11.19,31.67h.06l3.13.16v4.67H90.4V32.71l2.08-.16c1.15-.11,1.7-.44,1.32-1.65l-1.15-3.4H79.8l-1.64,4.83,3.29.16v4.67H68.77V32.71l1.81-.16c.94-.11,1.26-.5,1.65-1.54Zm.05,17H91.33L86.39,6.81h-.16Z"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  id: "crap-R",
  className: "crapomaticTitle2",
  d: "M32.05,32.71l1.81-.16c.94-.11,1.6-.44,1.6-1.54V5.49l-3.13-.17V.66h15c8.07,0,13.17,2.63,13.17,10.1a10.1,10.1,0,0,1-6.58,9.66c1.48.55,2.3,1.48,3.13,3.35L61,32.38l3.13.11v4.67H50.55V32.71l1.59-.16c1.26-.17,1.54-.66,1-1.76L50.6,25.3c-.76-1.7-1.53-2.52-3.45-2.52h-5v9.55l3.57.16v4.67H32.05ZM46.93,17.56c4.66,0,6.75-2.14,6.75-6C53.68,6.59,50.82,6,46.16,6h-4V17.56Z"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  id: "crap-C",
  className: "crapomaticTitle1",
  d: "M17.23,5.43c-6.91,0-10.37,4.94-10.37,13.23,0,8.62,2.85,13.94,10.48,13.78a14,14,0,0,0,4-.5c1-.33,1.15-.76,1.15-1.81V25.74l5.6.39v9.49a25.08,25.08,0,0,1-10.87,2.25C6.09,37.87,0,31.61,0,19.1,0,4.78,8.78,0,17.23,0A25.15,25.15,0,0,1,27.55,2.25v9.33L22,12V7.68c0-1-.16-1.48-1.15-1.81A12.94,12.94,0,0,0,17.23,5.43Z"
});

var SvgTitleCrapomatic = function SvgTitleCrapomatic(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "crapomatic-title",
    viewBox: "0 0 360.38 37.87",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTitleCrapomatic, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/title-crapomatic.747a047d.svg";
export { ForwardRef as ReactComponent };